import { Link } from 'react-router-dom';
import type { Project } from '../types';
import { PROJECT_STATUS_LABELS } from '../types';
import { useAppData } from '../store';

export default function ProjectCard({ project }: { project: Project }) {
  const { getAsset } = useAppData();
  const asset = getAsset(project.asset_id);

  return (
    <Link to={`/projects/${project.id}`} className={`card project-card status-${project.status}`}>
      <div className="project-card-main">
        <div className="project-card-title">
          <span className="name">{project.name}</span>
          <span className={`badge status-${project.status}`}>
            {PROJECT_STATUS_LABELS[project.status]}
          </span>
        </div>
        <div className="project-card-sub muted">
          {asset ? asset.name : 'No asset'}
          {project.target_timeframe ? ` · ${project.target_timeframe}` : ''}
        </div>
      </div>
      {project.estimated_budget != null && (
        <div className="project-card-meta muted">${project.estimated_budget.toLocaleString()}</div>
      )}
    </Link>
  );
}
